// extracted by mini-css-extract-plugin
export default {"root":"FeaturesSlice_root__VZegR"};